export const primaryYellow = 'rgb(248, 226, 37)';
export const primaryRed = 'rgb(229, 54, 33)';
export const primaryBlack = '#000';
export const primaryWhite = '#fff';
